import React from 'react';
import {
  Segment,
} from 'semantic-ui-react';

import CurrentlyLiveComponent from '../components/CurrentlyLive';

const CurrentlyLive = () => {
  return (
    <Segment inverted>
      <CurrentlyLiveComponent />
    </Segment>
  )
};

export default CurrentlyLive;
